<ul class="color-button-container"
    [ngStyle]="colorList">
    <li *ngFor="let color of legend"
    class="color-button"
    [ngClass]="{
        'active': internalSelected?.colorID === color?.colorID,
        'disabled':readOnly
    }"
    (click)="onColorClick(color)">
        <div class="color-button-circle"
            [style.backgroundColor]="color.color ? color.color : 'white'">
        </div>
        <p class="color-button-label">
            <span class="label-text">{{ color.alphaCode }}. {{ color.description }}</span>
            <span class="hidden-label-text-for-spacing">{{ color.alphaCode }}. {{ color.description }}</span>
        </p>
    </li>
</ul>

<div class="buttons-container" [ngClass]="{'button-container--gutter': isWithButtons && legend.length>0}">
    <div *ngIf="isWithButtons"
        class="legend-button-container">
        <legend-button
        *ngFor="let btn of parsedButtonsConfiguration"
        [buttonConfig]="btn"
        [disabled]="readOnly"
        (buttonClick)="onButtonClick($event.clickValue)"
        >
        </legend-button>
    </div>
    <ng-content select="[extra-buttons-before]"></ng-content>
</div>
